import { BINGO_LINES } from '../constants/bingo.constants';

export type BingoCell = {
	position: number;
	isHit: boolean;
	settledDate: Date | null;
};

export type CompletedBingoLine = {
	line: number;
	positions: number[];
	completedAt: Date;
};

export const getCompletedBingoLines = (cells: BingoCell[]): CompletedBingoLine[] => {
	const cellByPosition = new Map(cells.map((cell) => [cell.position, cell]));

	return BINGO_LINES.flatMap((positions, line) => {
		const settledTimes = positions.flatMap((position) => {
			const cell = cellByPosition.get(position);
			return cell?.isHit && cell.settledDate ? [cell.settledDate.getTime()] : [];
		});
		if (settledTimes.length < positions.length) return [];

		const completedAt = new Date(Math.max(...settledTimes));
		return [{ line, positions, completedAt }];
	});
};

export const getBingoAchievedAt = (lines: CompletedBingoLine[]): Date | null =>
	lines.length ? new Date(Math.min(...lines.map((line) => line.completedAt.getTime()))) : null;

/** Max number of hit cells across all bingo lines. */
export const getBestBingoLineHits = (cells: Pick<BingoCell, 'position' | 'isHit'>[]): number => {
	const hitPositions = new Set(cells.filter((cell) => cell.isHit).map((cell) => cell.position));

	return Math.max(
		0,
		...BINGO_LINES.map(
			(positions) => positions.filter((position) => hitPositions.has(position)).length
		)
	);
};
